import { ButtonProps } from "../../../../types"
import Button from "../button"

type Theme = "primary" | "danger" | "alt" | "light"
type Variant = "underline" | "ghost"

interface LinkBtnProps extends ButtonProps {
  theme?: Theme
  variant?: Variant
  borderClassName?: string
}

const themeClasses: Record<Theme, string> = {
  primary:
    "text-primary-400 hover:text-primary-500 focus:ring-primary-300 focus:ring-2 focus:ring-offset-0",
  danger:
    "text-red-400 hover:text-red-500 focus:ring-red-300 focus:ring-2 focus:ring-offset-0",
  alt: "text-primary-alt-400 hover:text-primary-alt-500 focus:ring-primary-alt-300 focus:ring-2 focus:ring-offset-0",
  light:
    "text-gray-500 hover:text-gray-700 focus:ring-gray-300 focus:ring-2 focus:ring-offset-0"
}

const ghostClasses: Record<Theme, string> = {
  primary: "hover:bg-primary-50 px-2",
  danger: "hover:bg-red-50  px-2",
  alt: "hover:bg-primary-alt-50 px-2",
  light: "hover:bg-gray-100 px-2"
}

const LinkBtn = ({
  theme = "primary",
  variant = "underline",
  children,
  className = "",
  text = "sm",
  paddingOff = false,
  borderClassName,
  ...rest
}: LinkBtnProps) => {
  const resolvedBorderClassName =
    borderClassName ??
    (variant === "ghost"
      ? `border-transparent bg-transparent ${ghostClasses[theme]}`
      : "border-transparent bg-transparent hover:underline")

  return (
    <Button
      {...rest}
      className={`${themeClasses[theme]} ${className} ${resolvedBorderClassName}`}
      text={text}
      paddingOff={paddingOff}
    >
      {children}
    </Button>
  )
}
export default LinkBtn
